import template from './eszkozkalkulator.pug';
import eszkozKalkulatorServiceModule from './eszkozkalkulator-service';
import moment from 'moment';
import 'angular-scroll';
import 'angular-messages';
import gepjarmuEvjarataValidator from './validators/gepjarmuevjaratvalidator';
import futamidoValidator from './validators/futamidovalidator';
import nettoMaradvanyertekValidator from './validators/nettomaradvanyertekvalidator';
import numberValidator from './validators/numbervalidator';
import sajatEroValidator from './validators/sajaterovalidator';
const MODULE_NAME = 'eszkozKalkulator';
const AGRAR_GEP = 'agrargep';
class EszkozKalkulatorController {
	constructor(eszkozKalkulatorService, eszkozKalkulatorConstants, $scope, $timeout, environment, $filter, $document) {
		'ngInject';
		this._eszkozKalkulatorService = eszkozKalkulatorService;
		this._eszkozKalkulatorConstants = eszkozKalkulatorConstants;
		this._$scope = $scope;
		this._$timeout = $timeout;
		this._environment = environment;
		this._$filter = $filter;
		this._$document = $document;
		this.nyiltveguMin = 12;
		this.nyiltveguMax = 72;
		this.zartveguMin = 36;
		this.zartveguMax = 60;
	}
	$onInit() {
		this.initData = {
			finanszirozandoEszkozFajtak: {},
			finanszirozasJellegek: {},
			finanszirozasFajtak: {},
			finanszirozasIgenylok: {},
			gepjarmuAllapotok: {},
			gepjarmuEredetek: {},
			devizanemek: {},
			gyartmanyok: {},
			megyek: [],
			torlesztesiUtemezesek: {},
			cascoTipusok: {},
			sajatErok: {}

		};
		this.finanszirozasFajtak = {};
		this.kalk = {};
		this.info = {};
		this.ajanlat = null;	//Ajánlat response Webservice-től, mely később szükséges metaadatokat is tartalmaz (pl. hitelkérelem azonosító).

		this.states = this._eszkozKalkulatorConstants.states;
		this.appState = this._eszkozKalkulatorConstants.states.AJANLAT_PAGE;



		/*
		 * Lock, ami a 4 egymást befolyásoló mező watch-ai közül csak egyet enged lefutni.
		 */
		this.szamitasSzukseges = true;

		/*
		 * A Nettó vételár, Regisztrációs adó, Áfa és Bruttó vételár mezők változtatása esetén megkülönböztetjük az új érték adását és a meglévő érték változtatását.
		 * Új érték adásának számít egy üres mező kitöltése, míg el nem veszíti a fókuszt.
		 */

		this._strategia = null;


		this._eszkozKalkulatorService.init().then((response) => {
			this.initData = response;
			this.kalk.finanszirozandoEszkozFajtaja = AGRAR_GEP;
			this.finanszirozasFajtak = this.initData.finanszirozasFajtak;
			this.initData.gepjarmuFajtak = [
				{
					name: 'L',
					value: 'Kishaszon-gépjármű'
				}
			];
			this.gepjarmuFajtaja = 'L';
			this.sajatEro = this.getFirstProperty(this.initData.sajatErok);
			this.nettoSajatEro = this.getFirstProperty(this.initData.nettoSajatErok);
			this.kalk.vallalkozasSzekhelye = this.initData.megyek[0];

			//select szűkített értékkészletek
			this._finanszirozasFajtakSzukitett = angular.copy(response.finanszirozasFajtak);
			delete this._finanszirozasFajtakSzukitett[3];
			this._gepjarmuEredetekSzukitett = angular.copy(response.gepjarmuEredetek);
			delete this._gepjarmuEredetekSzukitett[2];

		}, () => {
			this.technicalError = true;
		});

		this._$scope.$watch('$ctrl.kalk.finanszirozandoEszkozFajtaja', (newValue) => {
			if (newValue) {
				this.initEgyebMukodes();
			}
		});

		/*
		 * Eszköz állapota legördülőből Új-at választva, kitöltődik az Évjárat mai dátummal, és Eredet nem lehet IMPORT.
		 */
		this._$scope.$watch('$ctrl.kalk.eszkozAllapota', (newValue) => {
			if (newValue == 'N') {
				this.kalk.gepjarmuEvjarata = moment().format('YYYY-MM');
				this.gepjarmuEredetek = this._gepjarmuEredetekSzukitett;
				this.kalk.gepjarmuEredete = this.getFirstProperty(this._gepjarmuEredetekSzukitett);
			} else if (newValue == 'Y') {
				this.gepjarmuEredetek = this.initData.gepjarmuEredetek;
			}
		});


		/*
		 * Nettó maradványérték (számolt mező) számítása.
		 */
		this._$scope.$watchGroup(['$ctrl.kalk.nettoVetelar', '$ctrl.kalk.nettoMaradvanyertek'], () => {
			if (this.kalkulatorForm && typeof this.kalkulatorForm.nettoVetelar != 'undefined' && this.kalkulatorForm.nettoVetelar.$valid && typeof this.kalkulatorForm.nettoMaradvanyertek != 'undefined' && this.kalkulatorForm.nettoMaradvanyertek.$valid) {
				this.kalk.nettoMaradvanyertekFt = Math.round(this.kalk.nettoVetelar * this.kalk.nettoMaradvanyertek / 100);
			} else {
				this.kalk.nettoMaradvanyertekFt = null;
			}
		});

		/*
		 * Áfa (számolt mező) számítása WS 2 esetén.
		 */
		this._$scope.$watch('$ctrl.kalk.nettoVetelar', () => {
			this.kalk.afa = null;
			if (this.kalkulatorForm && typeof this.kalkulatorForm.nettoVetelar != 'undefined' && this.kalkulatorForm.nettoVetelar.$valid) {
				this.kalk.afa = Math.round(this.kalk.nettoVetelar * 0.27);
			}
		});

		this._$scope.$watchGroup(['$ctrl.sajatEro', '$ctrl.nettoSajatEro', '$ctrl.kalk.nettoVetelar', '$ctrl.kalk.finanszirozasFajtaja'], () => {
			if (typeof this.kalkulatorForm.nettoVetelar != 'undefined' && this.kalkulatorForm.nettoVetelar.$valid) {
				this.kalk.sajatEro = Math.round(this.kalk.nettoVetelar * this.sajatEro);
				this.afaUjErtek = false;
				var nettoVetelar = parseInt(this.kalk.nettoVetelar, 10);
				var sajatEroFinal;
				if (this.kalk.finanszirozasFajtaja == 2) {
					sajatEroFinal = parseInt(this.sajatEro, 10);
				} else if (this.kalk.finanszirozasFajtaja == 3) {
					sajatEroFinal = parseInt(this.nettoSajatEro, 10);
				}
				this.kalk.sajatEro = Math.round((nettoVetelar * sajatEroFinal) / 100 || 0);
			}
		});

		/*
		 * 4 egymást befolyásoló érték - Nettó vételár változása esetén
		 */
		this._$scope.$watch('$ctrl.kalk.nettoVetelar', () => {
			if (this.szamitasSzukseges) {
				this.szamitasSzukseges = false;

				if (this.kalkulatorForm && typeof this.kalkulatorForm.nettoVetelar != 'undefined' && this.kalk.nettoVetelar != null && this.kalkulatorForm.nettoVetelar.$valid) {
					if (this._strategia != null) { this._strategia(); }
				}

				this._$timeout(() => { this.szamitasSzukseges = true; }, 0);
			}
		});


		/*
		 * 4 egymást befolyásoló érték - Áfa változása esetén
		 */
		this._$scope.$watch('$ctrl.kalk.afa', () => {
			if (this.szamitasSzukseges) {
				this.szamitasSzukseges = false;

				if (typeof this.kalkulatorForm.afa != 'undefined' && this.kalk.afa != null && this.kalkulatorForm.afa.$valid) {
					if (this._strategia != null) { this._strategia(); }
				}

				this._$timeout(() => { this.szamitasSzukseges = true; }, 0);
			}
		});

		this._$scope.$watchGroup(['$ctrl.kalk.futamido', '$ctrl.kalk.nettoVetelar', '$ctrl.kalk.finanszirozasFajtaja'], () => {
			if (this.isFinanszirozasFajtajaNyiltvegu()) {
				if (this.kalk.futamido >= 0 && this.kalk.futamido <= 12) {
					this.kalk.nettoMaradvanyertek = 50;
				} else if (this.kalk.futamido <= 24) {
					this.kalk.nettoMaradvanyertek = 35;
				} else if (this.kalk.futamido <= 36) {
					this.kalk.nettoMaradvanyertek = 25;
				} else if (this.kalk.futamido <= 48) {
					this.kalk.nettoMaradvanyertek = 20;
				} else if (this.kalk.futamido <= 60) {
					this.kalk.nettoMaradvanyertek = 15;
				} else if (this.kalk.futamido <= 72) {
					this.kalk.nettoMaradvanyertek = 5;
				}
			} else {
				this.kalk.nettoMaradvanyertek = null;
			}
		});

		/*
		 * Ha sikeres számítás után hozzányúlnak a kalkulátorhoz, az ajánlatot nullázzuk.
		 */
		this._$scope.$watch('$ctrl.kalkulatorForm.$dirty', (newValue) => {
			if (newValue) {
				this.info = {};
				this.ajanlatForm.globalError.$setValidity('global', true);
			}
		});
	}
	futamidoValidacio() {
		if (this.kalkulatorForm.futamido.$valid) {
			this.kalk.futamido = parseInt(this.kalk.futamido, 10);
			if (this.kalk.futamido > (this.isFinanszirozasFajtajaNyiltvegu() ? this.nyiltveguMax : this.zartveguMax)) {
				this.kalk.futamido = (this.isFinanszirozasFajtajaNyiltvegu() ? this.nyiltveguMax : this.zartveguMax);
			}
			if (this.kalk.futamido < (this.isFinanszirozasFajtajaNyiltvegu() ? this.nyiltveguMin : this.zartveguMin)) {
				this.kalk.futamido = (this.isFinanszirozasFajtajaNyiltvegu() ? this.nyiltveguMin : this.zartveguMin);
			}
			if (this.isAgrarGep()) {
				var ma = new Date();
				var nap = ma.getDate();
				var honap = ma.getMonth() + 1;
				var elsoTorlesztoHonap;
				var utolsoTorlesztoHonap;
				var maradek;
				var ujFutamido;
				if (nap <= 17) {
					elsoTorlesztoHonap = honap;
				} else {
					elsoTorlesztoHonap = honap + 1;
				}
				utolsoTorlesztoHonap = elsoTorlesztoHonap + this.kalk.futamido - 1;
				maradek = utolsoTorlesztoHonap % 3;
				if (maradek == 0) {
					ujFutamido = this.kalk.futamido;
				} else {
					ujFutamido = this.kalk.futamido + 3 - maradek;
				}
				if (ujFutamido > this.zartveguMax) {
					ujFutamido = this.kalk.futamido - maradek;
				}

				this.kalk.futamido = ujFutamido;
			}
		}
	}
	kalkulal() {
		this.kalkulacioSubmitted = true;
		if (this.kalkulatorForm.$valid) {
			this.appState = this._eszkozKalkulatorConstants.states.AJANLAT_PAGE_LOADING;

			this._eszkozKalkulatorService.kalkulal(
				this.kalk,
				(response) => {
					this.appState = this._eszkozKalkulatorConstants.states.AJANLAT_PAGE;
					if (response) {

						this.info = {};

						if (response.sikeres) {
							this.globalError = null;
							this.ajanlat = response;

							this.info.haviLizingdij = (typeof this.ajanlat.haviTorlesztoReszlet != 'undefined' && this.ajanlat.haviTorlesztoReszlet != null) ? (this._$filter('number')(this.ajanlat.haviTorlesztoReszlet) + ',- Ft') : null;
							this.info.biztositasiDij = (typeof this.ajanlat.biztositasiDij != 'undefined' && this.ajanlat.biztositasiDij != null) ? (this._$filter('number')(this.ajanlat.biztositasiDij) + ',- Ft') : null;
							this.info.thm = (typeof this.ajanlat.thm != 'undefined' && this.ajanlat.thm != null) ? (this.ajanlat.thm + '%') : null;
							this.info.induloEvesUgyletiKamat = (typeof this.ajanlat.ugyletiKamat != 'undefined' && this.ajanlat.ugyletiKamat != null) ? (this.ajanlat.ugyletiKamat + '%') : null;
							this.info.torlesztesiUtemezesek = [];
							if (this.ajanlat.torlesztoreszlet) {
								var lines = this.ajanlat.torlesztoreszlet.split('\n');
								for (var line of lines) {
									var columns = line.split('\t');
									if (columns.length == 4) {
										var utemezes = {
											esedekesseg: columns[0],
											toke: columns[1],
											kamatbontas: columns[2],
											torlesztoreszlet: columns[3]
										};
										this.info.torlesztesiUtemezesek.push(utemezes);
									}
								}
							}

							this.info.ajanlatGombMegjelenik = true;

							this.kalkulatorForm.$setPristine();	//Ha sikeres számítás után hozzányúlnak a kalkulátorhoz, az ajánlatot nullázzuk.
						} else {
							this.globalError = response.publikusHibauzenet;
							this.ajanlatForm.globalError.$setValidity('global', false);

							this.info.ajanlatGombMegjelenik = false;
						}
						let formBottom = angular.element(document.getElementById('torlesztesi-utemezesek'));
						if (formBottom.length) {
							this._$timeout(() => {
								this._$document.scrollToElementAnimated(formBottom);
							}, 100);
						}
					}
				},
				() => {
					this.appState = this._eszkozKalkulatorConstants.states.AJANLAT_PAGE;
				}
			);
		}
	}
	erdekel() {
		this.ajanlatSubmitted = true;
		this.adatokForm.kapcsolattartoTelefon.$setValidity('format', true);
		this.adatokForm.kapcsolattartoEmail.$setValidity('format', true);
		this.adatokForm.captcha.$setValidity('format', true);
		this.adatokForm.globalError.$setValidity('global', true);
		if (this.adatokForm.$valid) {
			this.appState = this._eszkozKalkulatorConstants.states.ADATOK_PAGE_LOADING;

			this.adatok.request = this.kalk;
			this.adatok.request.finanszirozottOsszeg = this.getFinanszirozottOsszeg();
			this.adatok.response = this.ajanlat;
			this._eszkozKalkulatorService.erdekel(
				this.adatok,
				(response) => {
					this.appState = this._eszkozKalkulatorConstants.states.ADATOK_PAGE;
					if (response) {
						if (response.length == 0) {	// nem jött vissza szerveroldali hiba
							this.success = true;
						} else {
							this.captchaFrissites();
							this.adatok.captcha = null;

							for (var errorCode of response) {	// szerveroldali hibák megjelenítése
								if (errorCode == 'phone') {
									this.adatokForm.kapcsolattartoTelefon.$setValidity('format', false);
								} else if (errorCode == 'contact-email') {
									this.adatokForm.kapcsolattartoEmail.$setValidity('format', false);
								} else if (errorCode == 'captcha') {
									this.adatokForm.captcha.$setValidity('format', false);
								} else if (errorCode == 'service') {
									this.globalError = response.publikusHibauzenet;
									this.adatokForm.globalError.$setValidity('global', false);
								}
							}
						}
					}
				},
				() => {
					this.appState = this._eszkozKalkulatorConstants.states.ADATOK_PAGE;
				}
			);
		}
	}


	initEgyebMukodes() {
		if (this.isAgrarGep()) {
			this.finanszirozasFajtak = this._finanszirozasFajtakSzukitett;
		} else {
			this.finanszirozasFajtak = this.initData.finanszirozasFajtak;
		}
		this.kalk.finanszirozasJellege = 'B';
		this.kalk.eszkozAllapota = 'N';
		this.kalk.finanszirozasFajtaja = '2';
		this.kalk.devizanem = 'HUF';
		this.kalk.finanszirozasIgenyloje = '2';
		if (this.isAgrarGep()) {
			this.kalk.torlesztesiUtemezes = 'A';
		} else {
			this.kalk.torlesztesiUtemezes = '1';
		}
	}

	getFirstProperty(obj) {
		var firstProperty = null;
		for (var prop in obj) {
			firstProperty = prop;
			break;
		}
		return firstProperty;
	}

	captchaFrissites() {
		var most = new Date();
		this.adatokCaptcha = `${this._environment.backendUrl}/kaptcha/erdekelCaptcha?_t=${most.getTime()}`;
	}
	getFinanszirozottOsszeg() {
		var finanszirozottOsszeg = null;
		if (this.isFinanszirozasFajtajaNyiltvegu()) {
			if (typeof this.kalkulatorForm.nettoVetelar != 'undefined' && this.kalkulatorForm.nettoVetelar.$valid && typeof this.kalkulatorForm.regisztraciosAdo != 'undefined' && this.kalkulatorForm.regisztraciosAdo.$valid && typeof this.kalkulatorForm.sajatEro != 'undefined' && this.kalkulatorForm.sajatEro.$valid) {
				finanszirozottOsszeg = parseInt(this.kalk.nettoVetelar, 10) + parseInt(this.kalk.regisztraciosAdo, 10) - parseInt(this.kalk.sajatEro, 10);
			}
		} else {
			if (typeof this.kalkulatorForm.bruttoVetelar != 'undefined' && this.kalkulatorForm.bruttoVetelar.$valid && typeof this.kalkulatorForm.sajatEro != 'undefined' && this.kalkulatorForm.sajatEro.$valid) {
				finanszirozottOsszeg = this.kalk.bruttoVetelar - this.kalk.sajatEro;
			}
		}

		if (finanszirozottOsszeg != null && finanszirozottOsszeg < 0) {
			finanszirozottOsszeg = 0;
		}
		return finanszirozottOsszeg;
	}

	isFinanszirozasFajtajaNyiltvegu() {
		return (this.kalk.finanszirozasFajtaja == '3');
	}

	isFinanszirozasIgenylojeCeg() {
		return (this.kalk.finanszirozasIgenyloje == '2');
	}
	isAgrarGep() {
		return this.kalk.finanszirozandoEszkozFajtaja == AGRAR_GEP;
	}

}

export default angular.module(MODULE_NAME, [eszkozKalkulatorServiceModule, 'ngMessages', gepjarmuEvjarataValidator, futamidoValidator, nettoMaradvanyertekValidator, numberValidator, sajatEroValidator, 'duScroll'])
	.component('eszkozKalkulator', {
		controller: EszkozKalkulatorController,
		template: template()
	}).constant('eszkozKalkulatorConstants', {
		states: {
			AJANLAT_PAGE: 'AJANLAT_PAGE',
			AJANLAT_PAGE_LOADING: 'AJANLAT_PAGE_LOADING',
			ADATOK_PAGE: 'ADATOK_PAGE',
			ADATOK_PAGE_LOADING: 'ADATOK_PAGE_LOADING',
			SIKERES_AJANLATKERES_PAGE: 'SIKERES_AJANLATKERES_PAGE'
		},
		K: 27
	}).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/eszkozkalkulator/eszkozkalkulator.js